import { ServiceMaker, methods, services } from "../services";

export const createTemplateInapp = payload =>
  ServiceMaker(
    `/smsemail/templates`,
    methods.POST,
    services.master,
    payload
  );

export const updateTemplateInapp = payload =>
  ServiceMaker(
    `/smsemail/templates/${payload.id}`,
    methods.PUT,
    services.master,
    payload.data
  );

export const fetchInappTemplateAll = (payload) =>
  ServiceMaker(
    `/smsemail/templates?service=${payload.service}`,
    methods.GET,
    services.master,
    payload
  );
